import React, { Component } from 'react';

interface Props {
  setPageIndex: (index: number) => void,
  pageLen: number,
}
interface State {
  curPageIndex: number;
}
class Page extends Component<Props, State> {
    constructor(props: any) {
        super(props);
        this.state = {
            curPageIndex: 0,
        }
    }
    componentDidMount() {
        this.setState({
            curPageIndex: 0,
        })
    }
    prevPageHandler(): void {
        const { curPageIndex } = this.state;
        (curPageIndex > 0) ? this.changePage(curPageIndex - 1) : alert("已经是第一页了哦");
    }
    // 选择页码
    changePageHandler(e: any, i: number): void {
        this.changePage(i)
    }
    changePage(index: number): void {
        const { setPageIndex } = this.props;
        setPageIndex(index);
        this.setState({
            curPageIndex: index
        })
    }
    // 下一页
    nextPageHandler(): void {
        const { curPageIndex } = this.state;
        const { pageLen } = this.props;
       (curPageIndex < (pageLen - 1)) ? this.changePage(curPageIndex + 1) : alert("已经是最后页了哦");
    }

    render() {
        const { curPageIndex } = this.state;
        const { pageLen } = this.props;
        const list = [];
        if(pageLen > 1) {
            list.push(<li className="page_item page_prev" key='prev' onClick={(e) => this.prevPageHandler(e)}>{"上一页"}</li>);
            for(let i = 0; i < pageLen; i++) {
                if(curPageIndex === i){
                    list.push(<li className="page_item page_cont on" key={i} onClick={(e) => this.changePageHandler(e, i)}>{ i + 1 }</li>);
                } else {
                    list.push(<li className="page_item page_cont" key={i} onClick={(e) => this.changePageHandler(e, i)}>{ i  + 1}</li>);
                }
            }
            list.push(<li className="page_item page_next" key='next' onClick={(e) => this.nextPageHandler(e)}>{"下一页"}</li>);
        }
        return pageLen > 1 ? (
          <div className="page_wrap">
                <ul className="page_ul">
                  {list}
                </ul>
          </div>
        ): null;
    }
}
export default Page;
